module.exports = __webpack_public_path__ + "static/media/pemprov-logo.856428fe.png";